import { colorBlue500, colorTeal500 } from '@amzn/meridian-tokens/base/color';
import { css } from '@emotion/css';

export const cardTitle = css({
  color: colorBlue500,
  ':hover': {
    textDecoration: 'none',
  },
});

export const teal500Element = css({
  color: colorTeal500,
});

export const blue500Element = css({
  color: colorBlue500,
});

export const noDataImage = css({ maxWidth: '120px', maxHeight: '86px' });
